import { Controller } from "@hotwired/stimulus"
import {useMutation} from "stimulus-use";

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.isInitialized = false
    useMutation(this, { attributes: false, childList: true, subtree: true })
  }
  toggle() {
    this.element.classList.toggle("collapsed");
    this.saveStateToServer();
  }

  mutate(entries) {
    if (!this.isInitialized) {
      this.isInitialized = true
      return
    }

    for (const mutation of entries) {
      if (mutation.type === 'childList') {
        const itemsContainer = this.element.querySelector('.kanban-column-items')

        const isEmpty = itemsContainer && itemsContainer.innerHTML.trim() === ""
        const hasCollapsedClass = this.element.classList.contains("collapsed")
        const hasOpenedClass = this.element.classList.contains("opened")

        if (isEmpty && !hasCollapsedClass && !hasOpenedClass) {
          this.element.classList.add("collapsed")
          this.saveStateToServer()
        } else if (!isEmpty && hasCollapsedClass) {
          this.element.classList.remove("collapsed")
          this.saveStateToServer()
        }
      }
    }
  }

  saveStateToServer() {
    if (!this.hasUrlValue) return

    const isCollapsed = this.element.classList.contains("collapsed")
    const boardType = this.element.dataset.board
    const state = this.element.dataset.state

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
      },
      body: JSON.stringify({
        board_type: boardType,
        state: state,
        collapsed: isCollapsed
      })
    })
      .then(response => {
        if (!response.ok) console.error("Ошибка сохранения")
      })
      .catch(error => console.error("Ошибка сети при сохранении:", error))
  }

}
